import { Modal } from "bootstrap";

export const useModal = (option?: Partial<Modal.Options>) => {
  let modalOption: Modal.Options = {
    backdrop: true,
    keyboard: true,
    focus: true,
  };

  if (option) {
    modalOption = { ...modalOption, ...option };
  }

  const createModalDom = (
    options = { addHeader: true, addBody: true, addFooter: true }
  ) => {
    const modal = document.createElement("div");
    modal.classList.add("modal");
    modal.classList.add("user-select-none");
    modal.setAttribute("tabindex", "-1");

    const modalDialog = document.createElement("div");
    modalDialog.classList.add("modal-dialog");

    const modalContent = document.createElement("div");
    modalContent.classList.add("modal-content");

    const modalHeader = document.createElement("div");
    modalHeader.classList.add("modal-header");

    const modalBody = document.createElement("div");
    modalBody.classList.add("modal-body");

    const modalFooter = document.createElement("div");
    modalFooter.classList.add("modal-footer");

    options.addHeader && modalContent.appendChild(modalHeader);
    options.addBody && modalContent.appendChild(modalBody);
    options.addFooter && modalContent.appendChild(modalFooter);
    modalDialog.appendChild(modalContent);
    modal.appendChild(modalDialog);

    return {
      modal,
      modalDialog,
      modalContent,
      modalHeader,
      modalBody,
      modalFooter,
    };
  };

  const createCloseButton = (content: string) => {
    const button = document.createElement("button");
    button.type = "button";
    button.setAttribute("data-bs-dismiss", "modal");
    button.innerHTML = content;
    return button;
  };

  const createOpenButton = (content: string, target: string) => {
    const button = document.createElement("button");
    button.type = "button";
    button.setAttribute("data-bs-toggle", "modal");
    button.setAttribute("data-bs-target", target);
    button.innerHTML = content;
    return button;
  };

  type ModalDomOptions = {
    fade: boolean;
    static: boolean;
    scrollable: boolean;
    centered: boolean;
    show: boolean;
    size: "sm" | "lg" | "xl";
    fullscreen:
      | "always"
      | "sm-down"
      | "md-down"
      | "lg-down"
      | "xl-down"
      | "xxl-down";
  };
  const setModalDom = (
    modalDom: ReturnType<typeof createModalDom>,
    option: Partial<ModalDomOptions>
  ) => {
    option.fade && modalDom.modal.classList.add("fade");
    option.static && modalDom.modal.setAttribute("data-bs-backdrop", "static");
    option.scrollable &&
      modalDom.modalDialog.classList.add("modal-dialog-scrollable");
    option.centered &&
      modalDom.modalDialog.classList.add("modal-dialog-centered");
    option.show && modalDom.modal.classList.add("show");
    option.size && modalDom.modalDialog.classList.add(`modal-${option.size}`);
    const fullscreen =
      option.fullscreen === undefined
        ? undefined
        : option.fullscreen === "always"
        ? "modal-fullscreen"
        : `modal-fullscreen-${option.fullscreen}`;
    fullscreen && modalDom.modalDialog.classList.add(fullscreen);
    return modalDom;
  };

  const createModal = (
    modalDom: ReturnType<typeof createModalDom>,
    option?: Partial<Modal.Options>
  ) => {
    document.body.appendChild(modalDom.modal);
    const newOption = option ? { ...modalOption, ...option } : modalOption;
    const modal = new Modal(modalDom.modal, newOption);
    modalDom.modal.addEventListener("hidden.bs.modal", () => {
      modal.dispose();
      document.body.removeChild(modalDom.modal);
    });
    return modal;
  };

  return {
    createModalDom,
    createCloseButton,
    createOpenButton,
    setModalDom,
    createModal,
  };
};
